import { render, staticRenderFns } from "./promotion-rag-colour-renderer.vue?vue&type=template&id=26556ae8&scoped=true"
import script from "./promotion-rag-colour-renderer.vue?vue&type=script&lang=js"
export * from "./promotion-rag-colour-renderer.vue?vue&type=script&lang=js"
import style0 from "./promotion-rag-colour-renderer.vue?vue&type=style&index=0&id=26556ae8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26556ae8",
  null
  
)

export default component.exports